import { useCallback, useEffect, useState } from 'react';
import useDocumentMutation from '../useDocumentMutation';
import useEventListener from '../useEventListener';
function useElementDimensions(selector) {
  const [element, setElement] = useState(document.querySelector(selector));
  const [dimensions, setDimensions] = useState({});
  const handleDocumentMutation = useCallback(() => setElement(document.querySelector(selector)), [selector]);
  useDocumentMutation(handleDocumentMutation);
  const handleElementResize = useCallback(() => {
    if (element) {
      const {
        scrollHeight,
        clientHeight,
        scrollWidth,
        clientWidth
      } = element;
      const {
        top,
        right,
        bottom,
        left,
        width,
        height,
        x,
        y
      } = element.getBoundingClientRect();
      setDimensions({
        scrollHeight,
        clientHeight,
        scrollWidth,
        clientWidth,
        top,
        right,
        bottom,
        left,
        width,
        height,
        x,
        y
      });
    } else {
      setDimensions({});
    }
  }, [element]);
  useEventListener('resize', handleElementResize);
  useEffect(handleElementResize, [handleElementResize]);
  return dimensions;
}
export default useElementDimensions;